import { render } from "./PageList.vue?vue&type=template&id=87c48fa8&scoped=true"
import script from "./PageList.vue?vue&type=script&lang=js"
export * from "./PageList.vue?vue&type=script&lang=js"

import "./PageList.vue?vue&type=style&index=0&id=87c48fa8&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87c48fa8"]])

export default __exports__